export default "__VITE_ASSET__edpTbs5s__"